enum SiteTheme {
  MemberPlex = 'memberplex',
  Demo = 'demo',
  NccerSSO = 'nccer-sso',
  NccerBilling = 'nccer-billing',
  Gamsd = 'gamsd',
  Sna = 'sna',
  Default = 'default',
  Compass = 'compass',
  Smacna = 'smacna',
  Acs = 'acs',
  TeamsElite = 'teams-elite',
  Wca = 'wca',
  WcaBlue = 'wca-blue',
  UsAsean = 'us-asean',
  BayView = 'bay-view',
}
export default SiteTheme;
